// @flow
import React, { Component } from "react";

import type { ErrorsType } from "../../types/UserFormType";
import { StyledTextField, CancelButton, SubmitButton } from "imagus-components";
import { ErrosDisplay, setErrorMsg } from "../../containers/ErrosDisplay";

import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";

type GetDownloadLinkFormStatesType = {
  errors: ErrorsType,
  loading: boolean,
  days: number,
  links: Array<*>
};

type GetDownloadLinkFormPropsType = {
  linkList: Array<*>,
  onClose: Function,
  downloadFile: Function
};

const initialform: GetDownloadLinkFormStatesType = {
  errors: {},
  loading: false,
  days: 5,
  links: []
};

class GetDownloadLinkForm extends Component<
  GetDownloadLinkFormPropsType,
  GetDownloadLinkFormStatesType
> {
  constructor(props: GetDownloadLinkFormPropsType) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = initialform;
  }

  handleTextChange = (e: SyntheticInputEvent<*>): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  };

  submit = (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();
    if (Object.keys(this.state.errors).length === 0) {
      this.setState((): * => ({ loading: true }));

      this.props.linkList.map((item: *, i: number): * => {
        this.props.downloadFile(
          item.softwareId,
          item.versionId,
          this.state.days,
          this.submitDone(item.name),
          this.submitFail
        );
      });
    }
  };

  submitDone = (itemName: string): * => (url: string) => {
    let links = [...this.state.links];
    links.push({ url: url, name: itemName });
    this.setState({ links: links, loading: false });
  };

  submitFail = (errors: ErrorsType): * => {
    this.setState({
      errors: errors,
      loading: false
    });
  };

  render(): React$Element<*> {
    const errors = this.state.errors;
    const loading = this.state.loading;
    return (
      <form onSubmit={(!loading && this.submit) || undefined}>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <StyledTextField
              isRequired={true}
              label="Expires In Days"
              name="days"
              value={this.state.days}
              onChange={this.handleTextChange}
              inpuType="number"
            />
          </Grid>
          <Grid item xs={12} style={{ wordBreak: "break-all" }}>
            {this.state.links.map((link: string, i: number): * => (
              <div className="bottom-margin-10" key={i}>
                <span className="right-margin-5">{link.name}</span>
                <Link href={link.url}>{link.url}</Link>
              </div>
            ))}
          </Grid>
          <Grid item xs={12}>
            <ErrosDisplay errors={errors} form="get download" />
          </Grid>
          <Grid item xs={12}>
            <div className="form-right-btn-block">
              <CancelButton onClick={this.props.onClose} />
              <SubmitButton
                loading={loading}
                disabled={Object.keys(errors).length > 0}
              />
            </div>
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default GetDownloadLinkForm;
